import type { ImpactStatsBlockContent, ImpactStatItem } from "../types"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Card, CardContent, CardHeader } from "@/components/ui/card"

interface ImpactStatsBlockEditorProps {
  content: ImpactStatsBlockContent | null
  onChange: (content: ImpactStatsBlockContent) => void
}

const DEFAULT_STATS: ImpactStatItem[] = [
  { label: "Total Raised", value: "$0" },
  { label: "Supporters", value: "0" },
  { label: "Years Active", value: "0" },
]

export function ImpactStatsBlockEditor({ content, onChange }: ImpactStatsBlockEditorProps) {
  const c = content ?? {}
  const stats = c.stats?.length
    ? [...c.stats]
    : DEFAULT_STATS.map((s) => ({ ...s }))
  const update = (partial: Partial<ImpactStatsBlockContent>) =>
    onChange({ ...c, ...partial })
  const setStat = (i: number, field: "label" | "value", val: string) => {
    const next = [...stats]
    if (!next[i]) next[i] = { label: "", value: "" }
    next[i] = { ...next[i], [field]: val }
    update({ stats: next })
  }

  return (
    <Card>
      <CardHeader>
        <h3 className="text-base font-medium">Impact Stats</h3>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label>Heading</Label>
          <Input
            value={c.heading ?? "Our impact"}
            onChange={(e) => update({ heading: e.target.value })}
            placeholder="Our impact"
          />
        </div>
        <div className="space-y-3">
          <Label>Stats</Label>
          {[0, 1, 2].map((i) => (
            <div key={i} className="grid grid-cols-2 gap-2">
              <Input
                placeholder="Label"
                value={stats[i]?.label ?? ""}
                onChange={(e) => setStat(i, "label", e.target.value)}
              />
              <Input
                placeholder="Value"
                value={stats[i]?.value ?? ""}
                onChange={(e) => setStat(i, "value", e.target.value)}
              />
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}
